import React, { useEffect, useState } from "react";
import FlatList from "../Flats/FlatList";
import Header from "../../components/Header";
import { Typography, Row, Col } from "antd";
import { getCookie } from "../../utils";
import "./style.css";
import Card from "../../components/Card";
import { getFlats } from "../../services/flats";
import { getAllPhases, getUsers } from "../../services/users";
const { Title } = Typography;

const Home = () => {
  const [flats, setFlats] = useState<any[]>([]);
  const [users, setUsers] = useState<any[]>([]);
  const [phases, setPhases] = useState<any[]>([]);
  const fetchFlats = () => {
    getFlats().then((res) => {
      if (Array.isArray(res)) {
        setFlats([...res]);
      }
    });
  };
  const fetchUsers = () => {
    getUsers().then((res) => {
      if (Array.isArray(res)) {
        setUsers([...res]);
      }
    });
  };

  const fetchPhases = () => {
    getAllPhases().then((res) => {
      if (Array.isArray(res)) {
        setPhases([...res]);
      }
    });
  };

  const filterUsers = (phase_id: any) => {
    const filteredUsers = users?.filter((item) => item.phase_id === phase_id);
    return filteredUsers?.length;
  };

  const filterAllotedUsers = (phase_id: any) => {
    const filteredUsers = users?.filter((item) => item.phase_id === phase_id);
    return filteredUsers?.filter((item: any) => item?.flat_id)?.length > 10
      ? filteredUsers?.filter((item: any) => item?.flat_id)?.length
      : 0;
  };

  const filterLeftUsers = (phase_id: any) => {
    const filteredUsers = users?.filter((item) => item.phase_id === phase_id);
    return filteredUsers?.length -
      filteredUsers?.filter((item: any) => !item?.flat_id)?.length <=
      10
      ? filteredUsers?.length
      : filteredUsers?.filter((item: any) => !item?.flat_id)?.length;
  };

  useEffect(() => {
    fetchFlats();
    fetchUsers();
    fetchPhases();
  }, []);
  return (
    <Typography style={{ textAlign: "center" }} className="dashboard-container">
      <Title className="dashboard-title">
        <img
          src="/assets/images/logo.png"
          alt="logo"
          className="dashboard-logo"
        />
        Welcome {getCookie("name")} to DLDA US Nagar Portal
      </Title>

      <Row gutter={16} style={{ width: "calc(100% - 40px)", marginTop: 40 }}>
        <Col span={8}>
          <Card title="Total Flats" count={flats?.length} />
        </Col>
        <Col span={8}>
          <Card
            title="Assigned Flats"
            count={
              flats?.filter((item: any) => item?.user_id)?.length > 10
                ? flats?.filter((item: any) => item?.user_id)?.length
                : 0
            }
          />
        </Col>
        <Col span={8}>
          <Card
            title="Vacant Flats"
            count={
              flats?.length -
                flats?.filter((item: any) => !item?.user_id)?.length <=
              10
                ? flats?.length
                : flats?.filter((item: any) => !item?.user_id)?.length
            }
          />
        </Col>
        <Col span={8}>
          <Card title="Total Users" count={users?.length} />
        </Col>
        <Col span={8}>
          <Card
            title="Total Alloted Users"
            count={
              users?.filter((item: any) => item?.flat_id)?.length > 10
                ? users?.filter((item: any) => item?.flat_id)?.length
                : 0
            }
          />
        </Col>
        <Col span={8}>
          <Card
            title="Total Left Users"
            count={
              users?.length -
                users?.filter((item: any) => !item?.flat_id)?.length <=
              10
                ? users?.length
                : users?.filter((item: any) => !item?.flat_id)?.length
            }
          />
        </Col>
        {phases?.map((item) => (
          <>
            <Col span={8}>
              <Card
                title={`Phase ${item.phase_id} Users`}
                count={filterUsers(item.phase_id)}
              />
            </Col>
            <Col span={8}>
              <Card
                title={`Phase ${item.phase_id} Alloted Users`}
                count={filterAllotedUsers(item.phase_id)}
              />
            </Col>
            <Col span={8}>
              <Card
                title={`Phase ${item.phase_id} Left Users`}
                count={filterLeftUsers(item.phase_id)}
              />
            </Col>
          </>
        ))}
      </Row>
    </Typography>
  );
};

export default Home;
